import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

export type HttpState = {
  requestInProgress: boolean;
  count: number;
};

const initialState: HttpState = {
  requestInProgress: false,
  count: 0,
};

const slice = createSlice({
  name: 'http',
  initialState,
  reducers: {
    requestStart(state: HttpState, _action: PayloadAction<void>) {
      state.count += 1;
      state.requestInProgress = state.count > 0;
    },
    requestDone(state: HttpState, _action: PayloadAction<void>) {
      state.count = Math.max(0, state.count - 1);
      state.requestInProgress = state.count > 0;
    },
    requestError(state: HttpState, _action: PayloadAction<void>) {
      state.count = Math.max(0, state.count - 1);
      state.requestInProgress = state.count > 0;
    },
  },
});

export const { requestStart, requestDone, requestError } = slice.actions;
export const httpReducer = slice.reducer;
